import Content from "components/Content";
import * as S from "./Section.style";

const Section = ({ children, noPadding, fullWidth, ...props }) => {
  return (
    <S.Section {...props}>
      <Content noPadding={noPadding} fullWidth={fullWidth}>
        {children}
      </Content>
    </S.Section>
  );
};

export default Section;
